import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Heading, Image, Text } from '@grupoboticario/flora-react'

import useBreakpoint from '../hooks/useBreakpoint'
import { useTracking } from '../TrackingContext'
import Divider from './Divider'

const Addresses = () => {
  const data = useTracking()
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()

  const maskZipcode = (zip: string) => {
    const reg = /(\d{5})(\d{3})/g
    const rep = zip?.replace?.(reg, '$1-$2')

    return rep
  }

  const info = useMemo(() => (!data ? '' : data.orderTraceabilityModel), [data])

  if (!data) return <div />

  const spaceToDivideInPercent: string = useMemo(() => {
    const informations = [info?.nmTokenContratacao, info?.invoiceNumber, info?.nmRedespachoRastreio]

    return 100 / informations.filter((item) => !!item).length + '%'
  }, [info])

  return (
    <>
      <Box css={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
        <Box css={{ width: isMobile ? '100%' : '50%' }}>
          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('shippingCompany')}:
          </Heading>
          <Text className="text1 d-block">{info.orqOfertaContratada.orqTransportadora.nmTransportadora}</Text>
          <Image
            alt={info.orqOfertaContratada.orqTransportadora.nmTransportadora}
            src={info.orqOfertaContratada.orqTransportadora.nmLogotipo}
            size={100}
          />

          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('dispatcher')}:
          </Heading>
          <Text>{info.cadExpedidor.nmExpedidor}</Text>
        </Box>

        <Box css={{ width: isMobile ? '100%' : '50%' }}>
          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('from')}:
          </Heading>

          <Box css={{ display: 'flex', marginBottom: '20px' }}>
            <Box css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('cityState')}</Text>
              <Text className="text1 d-block">
                {`${info.cadExpedidor.tabFaixaLogradouro.tabMunicipio.nmMunicipio || ''} - ${
                  info.cadExpedidor.tabFaixaLogradouro.tabMunicipio.cdUf || ''
                }`}
              </Text>
            </Box>
            <Box className="fundo-azul" css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('originZipCode')}</Text>
              <Text className="text1 d-block">{maskZipcode(info.cadExpedidor.tabFaixaLogradouro.nuCep) || '-'}</Text>
            </Box>
          </Box>

          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('to')}:
          </Heading>

          <Box css={{ display: 'flex', marginBottom: '16px' }}>
            <Box css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('cityState')}</Text>
              <Text className="text1 d-block">{`${info.tabFaixaLogradouro.tabMunicipio.nmMunicipio} - ${info.tabFaixaLogradouro.tabMunicipio.cdUf}`}</Text>
            </Box>
            <Box css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('destinyZipCode')}</Text>
              <Text className="text1 d-block">{maskZipcode(info.tabFaixaLogradouro.nuCep)}</Text>
            </Box>
          </Box>

          <Box css={{ display: 'flex' }}>
            <Box css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('address')}:</Text>
              <Text className="text1 d-block">{info.tabFaixaLogradouro.tabLogradouro.nmLogradouro}</Text>
            </Box>
            <Box css={{ width: '50%' }}>
              <Text className="text2 d-block">{t('district')}:</Text>
              <Text className="text1 d-block">{info.tabFaixaLogradouro.tabBairro.nmBairro}</Text>
            </Box>
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box css={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '16px' : '0px' }}>
        <Box css={{ width: isMobile ? '100%' : spaceToDivideInPercent }}>
          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('objectCode')}:
          </Heading>
          <Text>{info.nmTokenContratacao || '-'}</Text>
        </Box>

        <Box css={{ width: isMobile ? '100%' : spaceToDivideInPercent }}>
          <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
            {t('invoiceNumber')}:
          </Heading>
          <Text>{!!Number(info.invoiceNumber) ? info.invoiceNumber : '-'}</Text>
        </Box>

        {info.nmRedespachoRastreio && (
          <Box css={{ width: isMobile ? '100%' : spaceToDivideInPercent }}>
            <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
              {t('mailCode')}:
            </Heading>
            <Text>{info.nmRedespachoRastreio}</Text>
          </Box>
        )}
      </Box>
    </>
  )
}

export default Addresses
